import { motion } from "framer-motion";

const variants = {
  up: { hidden: { y: 40, opacity: 0 }, show: { y: 0, opacity: 1 } },
  fade: { hidden: { opacity: 0 }, show: { opacity: 1 } },
  left: { hidden: { x: -50, opacity: 0 }, show: { x: 0, opacity: 1 } },
};

export const Reveal = ({ children, variant = "up", delay = 0, className = "", once = true, as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={variants[variant]}
      initial="hidden"
      whileInView="show"
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </MotionTag>
  );
};

export const StaggerGroup = ({ children, className = "", stagger = 0.12, instant = false }) => (
  <motion.div
    className={className}
    initial="hidden"
    {...(instant
      ? { animate: "show" }
      : { whileInView: "show", viewport: { once: true, margin: "-60px" } })}
    variants={{ show: { transition: { staggerChildren: stagger } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "" }) => (
  <motion.div className={className} variants={variants.up} transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}>
    {children}
  </motion.div>
);
